import { useContext } from 'react';
import DeviceContext from '../contexts/DeviceManagment';

const useDeviceManagment = () => useContext(DeviceContext);

export default useDeviceManagment;
